import type { ReportValueFormat } from '../../../types/reporting'

/**
 * Shared value formatter for report blocks (stat rows and table cells alike). Lives in its own
 * module rather than inside StatRowBlockView.tsx -- exporting a non-component from a component
 * file trips `react-refresh/only-export-components`, since Fast Refresh can't tell the export
 * apart from the component it boundary-checks.
 */
export function formatReportValue(value: number | null, format: ReportValueFormat): string {
  if (value === null || Number.isNaN(value)) return '—'
  switch (format) {
    case 'Percent': return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
    case 'Decimal': return value.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 2 })
    case 'Date': return new Date(value).toLocaleDateString()
    case 'Text': return String(value)
    case 'Number':
    default: return value.toLocaleString(undefined, { maximumFractionDigits: 0 })
  }
}
